export enum TextTag {
  Action = 'action',
  UI = 'ui'
}
